export default {
  serviceItem: {
    table: {
      Serialnumber: 'Serial Number',
      name: 'Name',
      timeConsuming:"Duration (Minutes)",
      type:"Type",
    },
  },
};
